import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { useModule } from '../context/ModuleContext';
import AppLogo from '../images/logo.png';
import { ChefHat, LogOut } from 'lucide-react';
import './CashierLayout.css';

interface KitchenLayoutProps {
  children: ReactNode;
}

const KitchenLayout: React.FC<KitchenLayoutProps> = ({ children }) => {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const { company } = useModule();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/waiter-login');
  };

  return (
    <div className="cashier-shell">
      <header className="cashier-header">
        <div className="cashier-header-left">
          <img src={AppLogo} alt="IMS" className="cashier-logo" />
          {company?.name && <span className="cashier-company">{company.name}</span>}
        </div>

        <nav className="cashier-nav">
          <span className="cashier-nav-link cashier-nav-link--active">
            <ChefHat size={16} strokeWidth={1.75} />
            {t('restaurant.kitchen.title', 'Kitchen Display')}
          </span>
        </nav>

        <div className="cashier-header-right">
          <span className="cashier-user">{user?.firstName} {user?.lastName}</span>
          <button className="cashier-logout-btn" onClick={handleLogout} title={t('restaurant.kitchen.switchStaff', 'Switch staff')}>
            <LogOut size={15} strokeWidth={1.75} />
            {t('restaurant.kitchen.switchStaff', 'Switch Staff')}
          </button>
        </div>
      </header>

      <main className="cashier-content">{children}</main>
    </div>
  );
};

export default KitchenLayout;
